export default "__VITE_PUBLIC_ASSET__58a42418__"